
import _ from "lodash";
import React, {  useEffect, useRef, useState } from "react";
import WaveSurfer from "wavesurfer.js";
import { secondsToTime } from "../../../../base/callService/common";
import { urlTranscription } from "../../../../base/callService/store_mining";
//import { Types } from "../../../../context/action/action";
import store from "../../../../context/store/store";
import { closeCaptionmeetingState } from "../../../../models/callModel";

const formWaveSurferOptions = (ref:any) => ({
  container: ref,
  waveColor: "#D3D6DE",
  progressColor: "#439CF3",
  cursorColor: "#439CF3",
  barWidth: 3,
  barRadius: 3,
  responsive: true,
  height: 80,
  barMinHeight: 15,
  barGap: 4,
  normalize: true,
  partialRender: true
});

type WaveFormVoicemailProps = {
  errorwave?: any
};

type WaveFormVoicemailstate = {
  timer: { h: string, m: string, s: string };
  isPlaying: boolean;
  isReady: boolean;
  duration: number;
};

export default function WaveFormVoicemail({errorwave}:WaveFormVoicemailProps) {
  const waveformRef:any = useRef(null);
  const wavesurfer: any = useRef(null);

  const [getData, setData] = useState<WaveFormVoicemailstate>({
    timer:{h:'00',m:'00',s:'00'}, isPlaying:false, isReady:false,duration:0
  });

  let { particularLog ,isParticularLoading} = store.getState().callReducer || [];
  let { leftSideWindow } = store.getState().updatedCallList;
  

  useEffect(() => {

    const options = formWaveSurferOptions(waveformRef.current);
    wavesurfer.current = WaveSurfer.create(options);
    if (!(_.isEmpty(particularLog)&&isParticularLoading)) {
      let url: string = leftSideWindow === 'recordList' ? particularLog?.recordingUrl : leftSideWindow === 'voiceMail' ? particularLog?.wavurl : '';       
      wavesurfer.current.load(url);
    }

    wavesurfer.current.on("ready", function() {
      let timer: any = secondsToTime(wavesurfer?.current?.getDuration());
      setData({
        ...getData, isPlaying: false,
        isReady: true, duration: wavesurfer.current.getDuration(), timer: timer
      });
    });

    wavesurfer.current.on("error", function(error:any) {
      errorwave(true);
      if (error !== "Error decoding audiobuffer") {
        // toastInformation('Corrupted  Audio Source',"failure");
      }
    });

    wavesurfer.current.on("audioprocess", function() {
      if (wavesurfer.current.isPlaying) {
        let timer: any = secondsToTime(wavesurfer?.current?.getDuration() - wavesurfer?.current?.getCurrentTime());
        
        setData({ ...getData, timer: timer, isPlaying: true, isReady: true });
   
        let ASR_Data: any = store.getState().ASR_Language || [];
        let ast_defaultOpt: string = ASR_Data.voice_speaker_lan || 'en';
        if (ast_defaultOpt !== 'en') {
          let closeCaption: closeCaptionmeetingState = store.getState().closeCaption || [];
          let key:any = timer.h + ":" + timer.m + ":" + timer.s;
          if (closeCaption.voiceDataStore.voiceCaption[key]) {
            urlTranscription(closeCaption.voiceDataStore.voiceCaption,
              closeCaption.voiceDataStore.voiceCaption[key][ASR_Data.voice_speaker_lan], key);
            delete closeCaption.voiceDataStore.voiceCaption[key];
          }
        }

      }
      else { setData({ ...getData, isPlaying: false,timer:{h:'00',m:'00',s:'00'} }); }
    });

    wavesurfer.current.on("finish", function() {
      setData({ ...getData, isPlaying: false, isReady:true,timer:{h:'00',m:'00',s:'00'} });
    });
 
    return () => { wavesurfer.current.destroy(); };

  }, [particularLog]);

  const handlePlayPause = () => {
    setData({ ...getData, isPlaying: !getData.isPlaying });
    wavesurfer.current.playPause();
  };

  return (
    <>
      <div className="wavesection">
        {getData.isReady &&
          <p><span onClick={handlePlayPause} className={getData.isPlaying ? "icon_pausebar" : "icon_play"}></span></p>
        }

        <div id="waveform" ref={waveformRef} />

        {getData.isReady &&
          <span>{((getData.timer.h !== '00') ? getData.timer.h : '') + getData.timer.m + ":" + getData.timer.s}</span>
        }
      </div>
    </>
  );
}